// Article Social Float - Handles floating social buttons on mobile
document.addEventListener('DOMContentLoaded', function () {
  // Only run on mobile and if we're on an article page
  if (window.innerWidth <= 1023 && document.querySelector('.article--indent-for-social')) {
    const shareBar = document.querySelector('.article__meta');
    const footer = document.querySelector('.main-footer');
    const article = document.querySelector('.article__content');

    if (shareBar && article) {
      let hasScrolledEnough = false;
      let lastScrollTop = 0;
      let isHiddenByScroll = false;

      // Function to check scroll position and direction
      function checkScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const articleTop = article.offsetTop;
        const triggerPoint = articleTop + 200; // Show after 200px of scrolling past article start

        // First check if we've scrolled enough to show the bar at all
        if (scrollTop > triggerPoint) {
          if (!hasScrolledEnough) {
            // First time crossing the trigger point while scrolling down
            hasScrolledEnough = true;
            if (!shareBar.classList.contains('hide-at-footer')) {
              shareBar.classList.add('is-visible');
              isHiddenByScroll = false;
            }
          }

          // Now check scroll direction
          if (scrollTop < lastScrollTop && scrollTop < lastScrollTop - 5) {
            // Scrolling up - hide the bar
            if (!isHiddenByScroll) {
              shareBar.classList.remove('is-visible');
              isHiddenByScroll = true;
            }
          } else if (scrollTop > lastScrollTop && scrollTop > lastScrollTop + 5) {
            // Scrolling down - show the bar (unless at footer)
            if (isHiddenByScroll && !shareBar.classList.contains('hide-at-footer')) {
              shareBar.classList.add('is-visible');
              isHiddenByScroll = false;
            }
          }
        } else {
          // Haven't scrolled enough - hide the bar
          shareBar.classList.remove('is-visible');
          hasScrolledEnough = false;
          isHiddenByScroll = false;
        }

        // Update last scroll position
        lastScrollTop = scrollTop;
      }

      // Initial check
      checkScroll();

      // Check on scroll
      let scrollTimer;
      window.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(checkScroll, 10);
      });

      // Footer intersection observer
      if (footer) {
        const observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting && hasScrolledEnough) {
                shareBar.classList.add('hide-at-footer');
                shareBar.classList.remove('is-visible');
              } else {
                shareBar.classList.remove('hide-at-footer');
                // Let scroll direction handle visibility - don't force it visible
              }
            });
          },
          {
            rootMargin: '100px'
          }
        );

        observer.observe(footer);
      }

      // Handle resize
      let resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (window.innerWidth > 1023) {
            shareBar.classList.remove('is-visible', 'hide-at-footer');
            lastScrollTop = 0;
            isHiddenByScroll = false;
          }
        }, 250);
      });
    }
  }
});
